import * as React from 'react'
import { Icon } from '@atoms'
import classnames from 'classnames'
import { hasVariance } from './hasVariance'

type VarianceBadgeProps = {
    previous: number
    current: number
    isReversed?: boolean
    classes?: string
    'data-testid'?: string
}

export const VarianceBadge: React.FC<VarianceBadgeProps> = ({
    current,
    previous,
    isReversed,
    classes = '',
    'data-testid': testId = 'variance-badge',
}) => {
    const variance = hasVariance({ current, previous })

    if (!variance) {
        return null
    }

    const isPositiveVariance = variance > 0
    const isGreenBadge = isReversed ? !isPositiveVariance : isPositiveVariance
    const formattedVariance = `${Math.abs(variance).toFixed(2)}%`
    const iconName = isPositiveVariance ? 'arrow_upward' : 'arrow_downward'
    const className = classnames(
        'text-label-xxsmall py-0.5 px-1 flex gap-0.5 items-center justify-center rounded',
        {
            'text-green-500 bg-green-50': isGreenBadge,
            'text-red-500 bg-red-50': !isGreenBadge,
        },
        classes
    )

    return (
        <div className={className} data-testid={testId}>
            <Icon name={iconName} size="xxsmall" />
            {formattedVariance}
        </div>
    )
}
